import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { UIInputPhoneComponent } from './ui-input-phone.component';
import { NzShareModule } from '../../nz/nz-share.module';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TextMaskModule,
        NzShareModule,
    ],
    declarations: [UIInputPhoneComponent],
    exports: [UIInputPhoneComponent],
})
export class UIInputPhoneModule {}
